import { render, staticRenderFns } from "./prepositioner-speciella-verbuttryck.vue?vue&type=template&id=f0a3557e&scoped=true"
import script from "./prepositioner-speciella-verbuttryck.vue?vue&type=script&lang=js"
export * from "./prepositioner-speciella-verbuttryck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a3557e",
  null
  
)

export default component.exports